import comp from "./StandardRubricEditCell";
export default comp;
